// Check for incomplete bundles on page load
(function() {
  // Function to check if a bundle is complete (has both coffee and machine)
  function isBundleComplete(bundleItems) {
    const hasCoffee = bundleItems.some(item => {
      const title = item.product_title.toLowerCase();
      return title.includes('coffee') && !title.includes('machine');
    });
    
    const hasMachine = bundleItems.some(item => {
      const title = item.product_title.toLowerCase();
      return title.includes('machine');
    });
    
    return hasCoffee && hasMachine;
  }
  
  // Function to check and remove incomplete bundles
  async function checkAndRemoveIncompleteBundles() {
    // Don't run on bundle builder pages - users need to complete the 2-step process
    if (window.location.pathname.includes('/loop_subscriptions/bundle/')) {
      console.log('On bundle page - skipping incomplete bundle check');
      return;
    }
    
    try {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await cartResponse.json();
      
      // Group items by bundle name
      const bundleGroups = {};
      
      cart.items.forEach(item => {
        const bundleName = item.properties?._bundleName;
        if (bundleName && bundleName.includes('Coffee Subscription')) {
          if (!bundleGroups[bundleName]) {
            bundleGroups[bundleName] = [];
          }
          bundleGroups[bundleName].push(item);
        }
      });
      
      // Check each bundle group for completeness
      const itemsToRemove = [];
      
      Object.entries(bundleGroups).forEach(([bundleName, bundleItems]) => {
        if (!isBundleComplete(bundleItems)) {
          console.log('Found incomplete bundle:', bundleName);
          bundleItems.forEach(item => {
            itemsToRemove.push(item.key);
            console.log('Will remove incomplete bundle item:', item.product_title);
          });
        }
      });
      
      // Remove incomplete bundle items
      if (itemsToRemove.length > 0) {
        console.log('Removing incomplete bundle items:', itemsToRemove);
        
        const updates = {};
        itemsToRemove.forEach(key => {
          updates[key] = 0;
        });
        
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });
        
        if (response.ok) {
          // Refresh cart display without full page reload
          if (window.location.pathname.includes('/cart')) {
            window.location.reload();
          } else {
            // Update cart count/icon if not on cart page
            const cartIconBubble = document.querySelector('cart-icon-bubble');
            if (cartIconBubble) {
              const updatedCart = await response.json();
              // Trigger cart update event
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { 
                  source: 'bundle-check', 
                  cartData: updatedCart 
                });
              }
            }
          }
        }
      }
    } catch (error) {
      console.error('Error checking incomplete bundles:', error);
    }
  }
  
  // Run check when page loads and Shopify is ready
  function runCheckWhenReady() {
    // Check if Shopify routes are available
    if (typeof window.Shopify === 'undefined' || !window.Shopify.routes) {
      // Wait a bit and try again
      setTimeout(runCheckWhenReady, 100);
      return;
    }
    
    checkAndRemoveIncompleteBundles();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCheckWhenReady);
  } else {
    // DOMContentLoaded already fired
    runCheckWhenReady();
  }
  
  // Also run check after cart updates (catches cases where user adds items)
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Wait a moment for cart to update fully
      setTimeout(checkAndRemoveIncompleteBundles, 500);
    });
  }
})();

// Intercept bundle removal clicks to handle subscription logic
(function() {
  // Function to check and handle subscription bundle removal
  async function handleSubscriptionBundleRemoval(bundleId) {
    try {
      // Fetch current cart to check what we're removing
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await cartResponse.json();
      
      // Find the item being removed by bundle ID
      const itemBeingRemoved = cart.items.find(item => {
        const itemBundleId = item.properties && item.properties._bundleId;
        return itemBundleId === bundleId;
      });
      
      console.log('Item being removed:', itemBeingRemoved);
      
      // Check if this item is part of a Coffee Subscription bundle
      const bundleName = itemBeingRemoved?.properties?._bundleName;
      const isSubscriptionBundle = bundleName && bundleName.includes('Coffee Subscription');
      
      if (!isSubscriptionBundle) {
        console.log('Not a Coffee Subscription bundle, letting Loop handle it');
        return false;
      }
      
      console.log('Found Coffee Subscription bundle:', bundleName);
      
      // Find all items with the same bundle name
      const bundleItems = cart.items.filter(item => {
        return item.properties && item.properties._bundleName === bundleName;
      });
      
      console.log('All items in this bundle type:', bundleItems);
      
      if (itemBeingRemoved && bundleItems.length > 0) {
        // This is part of the subscription bundle - remove ALL items in the bundle
        // (all coffee products + machine are paired and inseparable)
        
        console.log('Removing item from subscription bundle - will remove all paired items');
        
        // Remove ALL items with this bundle name (not just the one clicked)
        const itemsToRemove = [];
        
        bundleItems.forEach(item => {
          itemsToRemove.push(item.key);
          console.log('Found item to remove:', item.product_title, '(quantity:', item.quantity + ')');
        });
        
        console.log('Removing all bundle items:', itemsToRemove);
        
        // Remove all items
        const updates = {};
        itemsToRemove.forEach(key => {
          updates[key] = 0;
        });
        
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });
        
        if (response.ok) {
          window.location.reload();
        }
        return true; // Handled by us
      }
      
      return false; // Not handled, let Loop handle it
    } catch (error) {
      console.error('Error in subscription bundle removal:', error);
      return false;
    }
  }
  
  // Intercept clicks on bundle remove buttons
  document.addEventListener('click', function(event) {
    const target = event.target.closest('[onclick*="removeBundleLoop"]');
    
    if (target) {
      // Extract bundle ID from onclick attribute
      const onclickAttr = target.getAttribute('onclick');
      const bundleIdMatch = onclickAttr.match(/removeBundleLoop\(['"]([^'"]+)['"]\)/);
      
      if (bundleIdMatch) {
        const bundleId = bundleIdMatch[1];
        console.log('Intercepted removeBundleLoop call with bundleId:', bundleId);
        
        // Prevent default and handle it ourselves
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        handleSubscriptionBundleRemoval(bundleId).then(handled => {
          if (!handled) {
            // Let Loop handle it
            if (window.removeBundleLoop && typeof window.removeBundleLoop === 'function') {
              window.removeBundleLoop(bundleId);
            }
          }
        });
      }
    }
  }, true); // Use capture phase to intercept before Loop
})();

class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  }
  
  customElements.define('cart-remove-button', CartRemoveButton);
  
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement =
        document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
  
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);
  
      this.addEventListener('change', debouncedOnChange.bind(this));
    }
  
    cartUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      });
    }
  
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  
    resetQuantityInput(id) {
      const input = this.querySelector(`#Quantity-${id}`);
      input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    }
  
    setValidity(event, index, message) {
      event.target.setCustomValidity(message);
      event.target.reportValidity();
      this.resetQuantityInput(index);
      event.target.select();
    }
  
    validateQuantity(event) {
      const inputValue = parseInt(event.target.value);
      const index = event.target.dataset.index;
      let message = '';
  
      if (inputValue < event.target.dataset.min) {
        message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
      } else if (inputValue > parseInt(event.target.max)) {
        message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
      } else if (inputValue % parseInt(event.target.step) !== 0) {
        message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
      }
  
      if (message) {
        this.setValidity(event, index, message);
      } else {
        event.target.setCustomValidity('');
        event.target.reportValidity();
        this.updateQuantity(
          index,
          inputValue,
          document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId
        );
      }
    }
  
    onChange(event) {
      this.validateQuantity(event);
    }
  
    onCartUpdate() {
      if (this.tagName === 'CART-DRAWER-ITEMS') {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('cart-items');
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents',
        },
      ];
    }
  
    updateQuantity(line, quantity, name, variantId) {
      this.enableLoading(line);
  
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
  
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');
  
          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
  
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
  
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);
  
          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
  
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        })
        .catch(() => {
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }
  
    updateLiveRegions(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
  
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
      const cartStatus =
        document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
  
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.add('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  
    disableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.remove('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }
  
  customElements.define('cart-items', CartItems);
  
  if (!customElements.get('cart-note')) {
    customElements.define(
      'cart-note',
      class CartNote extends HTMLElement {
        constructor() {
          super();
  
          this.addEventListener(
            'input',
            debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
            }, ON_CHANGE_DEBOUNCE_TIMER)
          );
        }
      }
    );
  }
  